"use strict";

module.exports = {
  discoveryUrl: 'https://preference.preproduction-api.immediate.co.uk/docs/v1/swagger.json',
  environments: {
    staging: 'https://preference.staging-api.immediate.co.uk',
    preproduction: 'https://preference.preproduction-api.immediate.co.uk',
    production: 'https://preference.api.immediate.co.uk'
  },
  defaultHeaders: {
    'Content-Type': 'text/plain'
  }
};